var angular = require('angular');
var _module = require('./index');


_module
    .directive('fullscreenLoading', [
        function() {
            return {
                restrict: 'E',
                template: ''+
                    '<div class="fullscreen-loading" ng-hide="$disableFullscreenLoading">'+
                        '<div class="loader"><i class="fa fa-refresh fa-spin fa-2x"></i></div>'+
                    '</div>'+
                '',
                replace: true,
                link: function($scope, elem, attrs) {
                    $scope.$disableFullscreenLoading = false;

                    // $watch Functions
                    $scope.$watch(attrs.disable, function(newValue, oldValue) {
                        $scope.$disableFullscreenLoading = newValue;
                    });
                }
            };
        }
    ])
;